import { createElementBlock as e, defineComponent as t, openBlock as n, renderSlot as r } from "vue";
//#region src/shared/ScreenReader.vue?vue&type=script&setup=true&lang.ts
var i = {
	key: 0,
	class: "screenreader-only"
}, a = /*@__PURE__*/ t({
	__name: "ScreenReader",
	props: { if: {
		type: Boolean,
		default: !0
	} },
	setup(t) {
		return (t, a) => t.$props.if ? (n(), e("span", i, [r(t.$slots, "default")])) : r(t.$slots, "default", {}, void 0, void 0, 1);
	}
});
//#endregion
export { a as default };

//# sourceMappingURL=ScreenReader.vue.script.js.map